import angular, { ILogService, ISCEService, ITimeoutService } from 'angular'
import { chain, forEach, join, split } from 'lodash'
import { NotificacionService } from '../../../../_panel/module/uni-base/services/NotifService'
import { IEdicionPregunta, ISeleccionForm } from '../../../../model/candidato-api'
import { AccesoDatos } from '../../../comun/services/acceso-datos'
import { SubPregunta } from './subpregunta'
import { PregsState, PregState } from '../panel-preguntas/panel-preguntas.component'

class TarjetaPreguntaComponentCtrl {
  pregunta!: PregState
  pregsState!: PregsState

  dirty = false

  editando: boolean = false
  options: string[] = []
  subpregs: SubPregunta[] = []

  usosData = {
    visible: false,
    leido: false,
    list: [] as ISeleccionForm[],
  }

  constructor(
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[TarjetaPreguntaComponentCtrl] onInit')

    this._initPreg()

    if (!this.pregunta.datapreg.data.idquest) {
      // sin pregunta?
      this.editarPreg()
    }
  }

  private _initPreg() {
    // si es de tipo SELECT, hacer split de las opciones
    if (this.pregunta.datapreg.data && this.pregunta.datapreg.data.tipoq == 'SELECT')
      this.options = split(this.pregunta.datapreg.data.options, '|')

    // si es de tipo ROW, pintar las subpreguntas
    if (this.pregunta.datapreg.data && this.pregunta.datapreg.data.tipoq == 'ROW')
      this.subpregs = chain(this.pregunta.datapreg.subp)
        .map((subp) => new SubPregunta(subp))
        .value()

    this.dirty = false
  }

  $postLink() {
    // this.$timeout(() => (this.$element.find('select') as any).formSelect(), 10)
  }

  guardarPregunta() {
    // generar las opciones del select
    if (this.pregunta.datapreg.data.tipoq == 'SELECT') {
      this.pregunta.datapreg.data.options = join(this.options, '|')
    }

    // si es de tipo ROW, preparar las subpreguntas
    if (this.pregunta.datapreg.data.tipoq == 'ROW') {
      this.pregunta.datapreg.subp = this._generaSubPregs()
    } else this.pregunta.datapreg.subp = []

    this.AccesoDatos.Preg_CLIENT.nuevoPregunta(this.pregunta.datapreg).then((response) => {
      this.pregunta.datapreg = response

      this.dirty = false
    })
  }

  editarPreg() {
    this.editando = !this.editando

    if (this.editando) {
      this.$timeout(() => (this.$element.find('select') as any).formSelect(), 10)
      this.$timeout(() => {
        let textarea = this.$element.find('.materialize-textarea')

        if (textarea && textarea[0]) M.textareaAutoResize(textarea)
      }, 200)
    }
  }

  refreshPreg() {
    this.AccesoDatos.Preg_CLIENT.leerPregunta(this.pregunta.datapreg.data.idquest).then((response) => {
      this.pregunta.datapreg = {
        data: response.data,
        subp: response.subp,
        f: null,
        eliminar: false,
      }

      this._initPreg()
      this.editarPreg()
    })
  }

  cerrarUsosPreg() {
    this.usosData.visible = false
  }

  usosPreg() {
    this.AccesoDatos.Preg_CLIENT.usosPregunta(this.pregunta.datapreg.data.idquest).then((list) => {
      this.usosData = {
        visible: true,
        leido: true,
        list,
      }
    })
  }

  nuevaOpcion() {
    this.options.push('')

    this.dirty = true
  }

  splitOpcion(idx: number) {
    this.options.splice(idx, 1)

    this.dirty = true
  }

  splitOpcion_Subp($subp: SubPregunta, $idx: number) {
    $subp.splitOpcion($idx)

    this.dirty = true
  }

  nuevaOpcion_Subp($subp: SubPregunta) {
    $subp.nuevaOpcion()

    this.dirty = true
  }

  nuevaSubPreg() {
    this.subpregs.push(new SubPregunta({ data: { subpreg: true }, subp: [] } as IEdicionPregunta))
    this.$timeout(() => (this.$element.find('select') as any).formSelect(), 1)

    this.dirty = true
  }

  splitSubPreg(idx: number) {
    let subp = this.subpregs.splice(idx, 1)

    // marcar la subpregunta para eliminar
    forEach(subp, (p) => p.paraEliminar())

    this.dirty = true
  }

  private _generaSubPregs() {
    return chain(this.subpregs)
      .map((p) => p.paraGuardar())
      .value()
  }

  quitarMainQ() {
    this.pregunta.datapreg.data.mainq_id = null

    this.dirty = true
  }

  quitarMainQ_Subp($subp: SubPregunta) {
    $subp.p.data.mainq_id = null

    this.dirty = true
  }

  marcaListado(idx: number) {
    let subp = this.subpregs[idx]

    subp.p.data.listado = !subp.p.data.listado

    this.dirty = true
  }

  marcaExport(idx: number) {
    let subp = this.subpregs[idx]

    subp.p.data.exportar = !subp.p.data.exportar

    this.dirty = true
  }

  marcaRequired(idx: number) {
    let subp = this.subpregs[idx]

    subp.p.data.required = !subp.p.data.required

    this.dirty = true
  }

  marcaBuscar(idx: number) {
    let subp = this.subpregs[idx]

    subp.p.data.buscar = !subp.p.data.buscar

    this.dirty = true
  }

  marcaKeepHistory(idx: number) {
    let subp = this.subpregs[idx]

    subp.p.data.keep_history = !subp.p.data.keep_history

    this.dirty = true
  }

  marcaOmitirCoincidencias(idx: number) {
    let subp = this.subpregs[idx]

    subp.p.data.omit_history_match = !subp.p.data.omit_history_match

    this.dirty = true
  }
}

angular.module('candidato').component('tarjetaPregunta', {
  bindings: {
    pregunta: '<',
    pregsState: '<',
  },
  controller: TarjetaPreguntaComponentCtrl,
  template: require('./tarjeta-pregunta.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/tarjeta-pregunta/tarjeta-pregunta.component.html"
})

angular.module('candidato').filter('substr', ($sce: ISCEService) => {
  function t(text: string, n = 100) {
    if (!text || text.length < n) return text || ''

    return text.substr(0, n) + '&mldr;'
  }

  return (text: string, n = 100) => $sce.trustAsHtml(t(text, n))
})
